<template lang="pug">
  section
    b-field
      .tags.has-addons
        .tag.is-dark.is-large
          | 書籍名:ISBN
        b-tag(type="is-info" class="shinkan-tag" v-show="showStatus") {{ bookStockStatus }}
        .tag.is-large {{ bookName(book_id) }}
    b-field
      button(@click="submit" class="button is-danger" id="submit-button" :disabled="loading")
        i.fa.fa-plus.fa-fw
        | 配本登録
    .table-scroll.table-border.tfoot-fix-top
      b-table(
          narrowed
          hoverable
          striped
          icon-pack="fa"
          :data="data"
          :loading="loading"
          )
        template(slot-scope="props")
          b-table-column(field="shop_code" label="共有書店コード" width="120")
            | {{ props.row.shop_code }}
          b-table-column(field="book_shop_name" label="書店名" width="200")
            | {{ props.row.book_shop_name }}
          b-table-column(field="agency_code" label="帳合" width="80")
            | {{ agencyName(props.row.agency_code) }}
          b-table-column(field="order_route_id" label="受注経路" width="80")
            | {{ orderRouteName(props.row.order_route_id) }}
          b-table-column(field="deliver_type_id" label="出荷属性" width="80")
            | {{ deliverTypeName(props.row.deliver_type_id) }}
          b-table-column(field="kyakutyu_memo" label="客注メモ" width="200")
            | {{ props.row.kyakutyu_memo }}
          b-table-column(field="bibo" label="備忘" width="200")
            | {{ props.row.bibo }}
          b-table-column(field="accepting_date" label="受注日" width="100")
            | {{ props.row.accepting_date }}
          b-table-column(field="id" label="残数" width="80")
            | {{ props.row.remaining_order_number }}
          b-table-column(field="" label="大村在庫" width="140" class="has-all-check" centered)
            b-radio(v-model="props.row.manipulated_order_deliver_type_id" :native-value="deliverTypeId('大村在庫')" :disabled="isShinkan")
          b-table-column(field="" label="日販在庫" width="140" class="has-all-check" centered)
            b-radio(v-model="props.row.manipulated_order_deliver_type_id" :native-value="deliverTypeId('日販在庫')" :disabled="isShinkan")
          b-table-column(field="" label="トーハン在庫" width="160" class="has-all-check" centered)
            b-radio(v-model="props.row.manipulated_order_deliver_type_id" :native-value="deliverTypeId('トーハン在庫')" :disabled="isShinkan")
          b-table-column(field="" label="印刷所在庫" width="160" class="has-all-check" centered)
            b-radio(v-model="props.row.manipulated_order_deliver_type_id" :native-value="deliverTypeId('印刷所在庫')")
          b-table-column(field="" label="京北在庫" width="160" class="has-all-check" centered)
            b-radio(v-model="props.row.manipulated_order_deliver_type_id" :native-value="deliverTypeId('京北在庫')" :disabled="isShinkan")
          b-table-column(field="" label="文響社在庫" width="160" class="has-all-check" centered)
            b-radio(v-model="props.row.manipulated_order_deliver_type_id" :native-value="deliverTypeId('文響社在庫')" :disabled="isShinkan")
        template(slot="footer")
          th.is-hidden-mobile(width="120")
          th.is-hidden-mobile(width="200")
          th.is-hidden-mobile(width="80")
          th.is-hidden-mobile(width="80")
          th.is-hidden-mobile(width="80")
          th.is-hidden-mobile(width="200")
          th.is-hidden-mobile(width="200")
          th.is-hidden-mobile(width="100")
          th.is-hidden-mobile(width="300")
          th.is-hidden-mobile(width="140")
            div.th-wrap.button-all-check-wrap
              button.button-all-check(@click="checkAllRadioButton(deliverTypeId('大村在庫'))" :disabled="isShinkan") 全選択
          th.is-hidden-mobile(width="140")
            div.th-wrap.button-all-check-wrap
              button.button-all-check(@click="checkAllRadioButton(deliverTypeId('日販在庫'))" :disabled="isShinkan") 全選択
          th.is-hidden-mobile(width="160")
            div.th-wrap.button-all-check-wrap
              button.button-all-check(@click="checkAllRadioButton(deliverTypeId('トーハン在庫'))" :disabled="isShinkan") 全選択
          th.is-hidden-mobile(width="160")
            div.th-wrap.button-all-check-wrap
              button.button-all-check(@click="checkAllRadioButton(deliverTypeId('印刷所在庫'))") 全選択
          th.is-hidden-mobile(width="160")
            div.th-wrap.button-all-check-wrap
              button.button-all-check(@click="checkAllRadioButton(deliverTypeId('京北在庫'))" :disabled="isShinkan") 全選択
          th.is-hidden-mobile(width="125")
            div.th-wrap.button-all-check-wrap
              button.button-all-check(@click="checkAllRadioButton(deliverTypeId('文響社在庫'))" :disabled="isShinkan") 全選択
    b-field
      button(@click="submit" class="button is-danger" :disabled="loading")
        i.fa.fa-plus.fa-fw
        | 配本登録
</template>

<script>
import CacheDispatcher from 'mixins/cache_dispatcher'

export default {
  name: "new-multiple-manipulated-orders-for-book",
  mixins: [CacheDispatcher],
  data() {
    return {
      data: [],
      total: 0,
      loading: false,
      sortField: 'vote_count',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 25,
      isComponentModalActive: false,
      formProps: {
        shop_code_cont: '',
        name_cont: '',
        group_code_cont: '',
        telephone_cont: '',
        prefecture_cont: '',
        s: ''
      },
      default_params: null,
    }
  },
  props: {
    book_id: {
        type: Number,
        required: true
    },
  },
  // components: { 'search-modal-form': SearchModalForm },
  computed: {
    agencies(){ return this.$store.getters['Agencies/records'] },
    books(){  return this.$store.getters['Books/records'] },
    deliver_types(){  return this.$store.getters['DeliverTypes/records'] },
    accepting_order_routes(){  return this.$store.getters['AcceptingOrderRoutes/records'] },
    users(){ return this.$store.getters['Users/records'] },
    book() { return this.getBook(this.book_id) },
    isShinkan() {
      if(!this.book) return false
      return (this.book.book_stock_status == "新刊") ? true : false
    },
    showStatus() {
      if(!this.book) return false
      return (this.book.book_stock_status == "在庫あり") ? false : true
    },
    bookStockStatus() {
      if(!this.book) return ''
      return this.book.book_stock_status
    },
  },
  methods: {
    openNew(){
    },
    /*
     * Load async data
     */
    onClick(row){
    },
    async submit(){
      var method = 'post'
      var url = `/api/v1/multiple_manipulated_orders.json`
      var manipulated_order_items = this.data.map((item) =>{
        return {
          accepting_order_item_id: item.id,
          order_number: parseInt(item.remaining_order_number),
          deliver_type_id: item.manipulated_order_deliver_type_id,
        }
      })
      var params = {
        multiple_manipulated_order: {
          manipulated_order_items_attributes: manipulated_order_items
        }
      }
      this.loading = true
      this.error_message = null
      try{
        const res = await this.$http({ method: method, url: url, data: params })
        this.loading = false
        window.location.href = `/users/accepting_order_items/books`
      }catch (error) {
        const {
          status,
          statusText,
          data
        } = error.response;
        this.loading = false
        this.error_message = data.message.map((msg) => { return msg.message }).join(",")
        throw error
      }
    },
    agencyName(agency_code){
      if (!agency_code) return ''
      let tmp = this.agencies
          .filter(agency => agency.code == agency_code)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    bookName(value){
      let a = this.getBook(value)
      return a != null ? `${a.name}: ${a.isbn}` : ''
    },
    bookAuthor(value){
      let a = this.getBook(value)
      return a != null ? `${a.author}` : ''
    },
    bookReleasedOn(value){
      let a = this.getBook(value)
      return a != null ? `${a.released_on}` : ''
    },
    bookSellingPrice(value){
      let a = this.getBook(value)
      return a != null ? `${a.selling_price}` : ''
    },
    getBook(value){
      if (!value) return null
      let a = this.books.filter(book => book.isbn == value || book.id == value)
      return a.length > 0 ? a[0] : null
    },
    orderRouteName(id){
      if (!id) return ''
      let tmp = this.accepting_order_routes
          .filter(route => route.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    deliverTypeName(id){
      if (!id) return ''
      let tmp = this.deliver_types
          .filter(type => type.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    deliverTypeId(deliverTypeName) {
      if(!deliverTypeName) return null
      let tmp = this.deliver_types.filter(type => type.name == deliverTypeName)
      if(tmp.length == 0)
        return null
      return tmp[0].id
    },
    userName(id){
      if (!id) return ''
      let tmp = this.users
          .filter(user => user.id == id)
      if(tmp.length == 0)
        return ''
      return tmp[0].name
    },
    loadAsyncData() {
      this.loading = true
      let perPage = 9999999
      this.$http.get(`/api/v1/accepting_order_items?q[book_id_eq]=${this.book_id}&per_page=${perPage}&q[only_uncompleted]=true`)
          .then(({data}) => {
            this.data = []
            data.accepting_order_items.forEach((item) => {
             if(['大村在庫','日販在庫','トーハン在庫','印刷所在庫','京北在庫','文響社在庫'].includes(this.deliverTypeName(item.deliver_type_id)))
                item['manipulated_order_deliver_type_id'] = item.deliver_type_id
              else
                item['manipulated_order_deliver_type_id'] = 1
              item['remaining_order_number'] = item.order_number - item.delivered_number
              this.data.push(item)
            })
            this.loading = false
          })
          .catch((error) => {
            this.data = []
            this.total = 0
            this.loading = false
            throw error
          })
    },
    checkAllRadioButton(value) {
      this.data.forEach(d => {
        d.manipulated_order_deliver_type_id = value
      })
    }
  },
  filters: {
    /**
     * Filter to truncate string, accepts a length parameter
     */
    truncate(value, length) {
      return value.length > length
          ? value.substr(0, length) + '...'
          : value
    }
  },
  created(){
    this.default_params = '?' + [
      `page=${this.page}`,
      Object.keys(this.formProps).map((key) => {
        return `q[${key}]=${this.formProps[key]}`
      }).join('&')
    ].join('&')

    this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
    this.$store.dispatch('Books/fetch', 'books')
    this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
    this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
    this.$store.dispatch('Users/fetch', 'users')
  },
  mounted() {

    this.loadAsyncData()
  }
}

</script>

<style scoped>
.button-all-check-wrap {
  margin-top: 20px;
}
</style>
